import Vue from 'vue';

import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'
import './assets/css/theme-green/edit.css';
/*原始登录页css*/
import './assets/css/button.css';
import './assets/css/list.css';
import './assets/css/lianmeng/lm.css'
import './assets/css/list-lx.css';
import './assets/css/Resolution/MaxHeight.css'; //媒体查询
import './assets/css/Resolution/MaxWidth.css'; //媒体查询
import './assets/css/CompatibleProcessing/IE8TheAbove.css'; //媒体查询
import './assets/css/CompatibleProcessing/IE8TheFollowing.css'; //媒体查询
import './assets/css/loaders.css';
import './assets/css/icon.css';
import drag from '@/utils/drag.js';
import './assets/font_icon/iconfont.css';
import './assets/menu_icon/iconfont.css';
import './assets/font_wash/iconfont.css';
import './components/common/directives';
import './assets/menuicon';


// 引入样式
import TitleComp from '@/components/common/TitleComponent.vue';
import PageHeader from '@/components/common/PageHeader.vue';
import ImportComponent from '@/components/common/ImportComponent.vue';
import RequiredTip from '@/components/common/RequiredTip.vue'
import suspendCompoent from '@/components/common/SuspendComponent.vue';
/*vue-resource*/
import VueResource from 'vue-resource';

Vue.use(VueResource);

// 注册到全局
Vue.component('PageHeader', PageHeader);
Vue.component('ReqTip', RequiredTip);
Vue.component('SuspendCompoent', suspendCompoent);
Vue.component('ImportComponent', ImportComponent);

import Fenye from '@/components/lianmeng/common/Fenye.vue'
Vue.component('Fenye', Fenye);
import GloabelVariables from '@/components/const/GloabelVariables.vue';

Vue.prototype.GLOBAL = GloabelVariables;

// main.js注册
import FenyePlugin from '@/plugs/fenye.js'
Vue.use(FenyePlugin)

//定义全局刷新选中函数,适用于左侧树，右侧列表的选中问题

/*
 * middletableurl,中间表的controller的urlmapping
 * parentIdName,节点id的名称 对应实体类的字段名
 * parentId, 节点id的value
 * targeIdName,目标id的name，对应实体类的字段名
 * list 目标列表的数据数组
 * */
Vue.prototype.reSelectTable = function (middletableurl, parentIdName, parentId, targeIdName, list) {
	var that = this;
	var paramObj = {};
	paramObj[parentIdName] = parentId;
	e.$ajax.post(middletableurl, paramObj).then(function (response) {
		if (response.data.code == 200) {
			var selectedtrs = response.data.obj;
			if (selectedtrs.length > 0) {
				for (var i in selectedtrs) {
					for (var j in list) {
						if (selectedtrs[i][targeIdName] == list[j].id) {
							that.$refs.multipleTable.toggleRowSelection(list[j], true);
						}
					}
				}
			}
		}
	});
};

// 监听session变化判断是否需要重新加载图表
Vue.prototype.resetSetItem = function (key, newVal) {
	if (key == 'isReset') {
		// 创建一个StorageEvent事件
		var newStorageEvent = document.createEvent('StorageEvent');
		const storage = {
			setItem: function (k, val) {
				sessionStorage.setItem(k, val);

				// 初始化创建的事件
				newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

				// 派发对象
				window.dispatchEvent(newStorageEvent);
			}
		};
		return storage.setItem(key, newVal);
	}
};

// Vue.use(VueRouter);
import tools from '@/components/common/util';

Vue.use(tools);

Vue.use(scroll);


Vue.config.productionTip = false;
Vue.use(ElementUI, {
	size: 'small',
});

import expressName from './components/common/expressName';

Vue.prototype.COMMON = expressName;



//loading加载
import { Loading } from 'element-ui';

Vue.use(Loading);

import axios from 'axios';
import VueAxios from 'vue-axios';


axios.defaults.baseURL = "/";
// axios.defaults.baseURL = "";

// axios.defaults.withCredentials=true;
Vue.prototype.$ajax = axios;

import { endLoading, showLoading, hideLoading } from './loading';

// require styles 引入样式
import elementui from 'element-ui';

Vue.use(elementui, { zIndex: 1000 });
//使用axios发送请求的设置
// 在发送请求之前做某件事
axios.interceptors.request.use(
	config => {
		//todo 其他的url仿照此在线阅读的在这里改一下
		if (config.url.indexOf('/onlineview') > -1) {
			config.baseURL = '';
		}
		if (config.url == '/damTask/startByTask' || config.url.indexOf('datawikipedia/queryProcesshandlingStatics') > -1
			|| config.url.indexOf('datawikipedia/queryProcesstypestatistics') > -1
			|| config.url.indexOf('/datawikipedia/queryExchangeWithMdByPage') > -1
			|| config.url.indexOf('/difyllmAI/chat') > -1
			|| config.url.indexOf('damTask/taskProcessing') > -1) {

		} else {
			showLoading();
		}
		//本案例中将token保存到了sessionStorage，将其添加到请求头
		var token = sessionStorage.getItem('Authorization');
		config.headers['Authorization'] = 'Bearer ' + sessionStorage.getItem('Authorization');
		return config;
	},
	error => {
		hideLoading();
		this.$notify.warning({ title: '提示', message: '错误的传参' });
		return Promise.reject(error);
	}
);

axios.interceptors.response.use(
	response => {
		hideLoading();
		if (response.data.msg == 'expiredToken') {
			this.$notify('session已过期，请退出重新登录!');
			return;
		} else {
			return response;
		}
	},
	error => {
		hideLoading();
	}
);

//解决一个小bug问题
import Router from 'vue-router';

const originalPush = Router.prototype.push;
Router.prototype.push = function push (location) {
	return originalPush.call(this, location).catch(err => err);
};

//超级管理员
const superman = 'admin';
//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {

	var flag = 0;
	next();

	// if (to.path == '/login' || to.path == '/' || to.path == '/403' || to.path == '/sso' || to.path == '/HuiFaOaLogin' || to.path == '/LvXueOaLogin' || to.path == '/ChuandianOaLogin') {
	// 	next();
	// } else {
	// 	const roles = JSON.parse(sessionStorage.getItem('userinfo')).infoRoles
	// 	if (roles === 'undefined' || roles == null || roles.length == 0) {
	// 		next('/');
	// 	} else {
	// 		next();
	// 	}
	// }
});

import './utils/dialog';

new Vue({
	router,
	render: h => h(App)
}).$mount('#app');

//引入打印插件

// vue 打印插件
import Print from '@/plugs/print';

Vue.use(Print);

import tbutil from '@/components/common/tbutil';

Vue.use(tbutil);
